var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-manager-link-selector"
    },
    [
      _vm.ownId !== null
        ? _c("courseware-manager-element", {
            attrs: {
              type: "link",
              currentElement: _vm.ownElement,
              elementsOnly: true
            },
            on: {
              selectElement: _vm.setOwnId,
              loadSelf: _vm.loadSelf
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }